import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from '@shared/shared.module';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {
  InvoiceStatusWidgetComponent
} from '@feature/invoice-status/containers/invoice-status-widget/invoice-status-widget.component';
import {InvoiceStatusWidgetFacade} from '@feature/invoice-status/services/invoice-status-widget.facade';
import {InvoiceStatusWidgetEffects} from '@feature/invoice-status/effects/invoice-status-widget';
import * as widgetReducer from '@feature/invoice-status/reducers/invoice-status-widget';
import {InvoiceStatusWidgetHttpService} from '@feature/invoice-status/services/invoice-status-widget-http.service';
import {InvoiceStatusTableComponent} from './components/invoice-status-table/invoice-status-table.component';
import {InvoiceStatusVolumeComponent} from './components/invoice-status-volume/invoice-status-volume.component';
import {InvoiceStatusAmountComponent} from './components/invoice-status-amount/invoice-status-amount.component';
import {InvoiceStatusWidgetAdminHandler} from './services/invoice-status-widget-admin-handler.service';

@NgModule({
  declarations: [
    InvoiceStatusWidgetComponent,
    InvoiceStatusTableComponent,
    InvoiceStatusVolumeComponent,
    InvoiceStatusAmountComponent
  ],
  providers: [
    InvoiceStatusWidgetFacade,
    InvoiceStatusWidgetHttpService,
    InvoiceStatusWidgetAdminHandler,
  ],
  imports: [
    CommonModule,
    SharedModule,
    StoreModule.forFeature(widgetReducer.invoiceStatusWidgetFeature, widgetReducer.reducer),
    EffectsModule.forFeature([InvoiceStatusWidgetEffects])
  ],
  exports: [
    InvoiceStatusWidgetComponent,
    InvoiceStatusTableComponent
  ]
})
export class InvoiceStatusModule {
}
